/** Canonical location + map (single source for hero, footer, contact). */
export const ICEM_MAP_URL =
  "https://www.google.com/maps?q=32.4286667%2C71.3063611&z=17";

export const ICEM_ADDRESS_LINE = "Chashma Mali Khel, D I Khan";

export const ICEM_ADDRESS_FULL = "Chashma Mali Khel, Khyber Pakhtunkhwa, Pakistan";
